import { Icon, Paper, Typography } from '@material-ui/core'
import { DocumentContext } from 'context'
import {
  COMPLETED_PATH,
  DOCUMENT_PATH,
  ENTERED_PATH,
  ON_HOLD_RETENTION_PATH,
  PENDING_PATH,
  REJECTED_PATH,
  WAITING_PATH,
} from 'lib'
import React from 'react'
import CountUp from 'react-countup'
import { useHistory, useLocation } from 'react-router-dom'

interface Props {
  countPath?: string
}

interface CountCardProps {
  label: string
  value: number
  icon: string
  backgroundColor: string
  recount: number
  onClick: (e?: React.MouseEvent) => void
}

const CountCard = React.memo((props: CountCardProps) => {
  const { label, value, icon, backgroundColor, recount, onClick } = props

  return (
    <Paper
      className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
      style={{
        backgroundColor,
        flex: 1,
      }}
      elevation={0}
      onClick={onClick}
    >
      <div className="glass-md flex items-center justify-center p-2">
        <Icon style={{ color: '#FFFFFF' }}>{icon}</Icon>
      </div>

      <div className="ml-4">
        <CountUp start={recount} duration={1} end={value}>
          {({ countUpRef }) => (
            <Typography
              variant="h5"
              style={{ fontWeight: 900, color: '#FAFAFA' }}
            >
              <span ref={countUpRef} />
            </Typography>
          )}
        </CountUp>

        <Typography
          variant="caption"
          className="opacity-75 font-bold"
          style={{ color: '#FAFAFA' }}
        >
          {label}
        </Typography>
      </div>
    </Paper>
  )
})

const CountDocuments = React.memo((props: Props) => {
  const { countPath } = props
  const { count } = React.useContext(DocumentContext)

  const {
    completed,
    rejected,
    pending,
    total,
    entered,
    error,
    unsend,
    onhold,
  } = count

  const [recount, setRecount] = React.useState<number>(0)

  const history = useHistory()
  const location = useLocation()

  React.useEffect(() => {
    setRecount(Math.random())
  }, [])

  const hidePendingRejected =
    location.pathname === '/income/invoice/dashboard' ||
    location.pathname === '/document/retention/dashboard'

  return (
    <div className="flex items-center w-full pb-4 justify-between">
      
      {!hidePendingRejected && (
      <CountCard
        label="Total"
        value={entered}
        icon="arrow_upward"
        backgroundColor="#2563EB"
        recount={recount}
        onClick={() =>
          history.push(`${countPath ?? DOCUMENT_PATH}${ENTERED_PATH}`)
        }
      />
      )}

      {!hidePendingRejected && (
        <CountCard
          label="Ingresados"
          value={entered}
          icon="arrow_upward"
          backgroundColor="#0F766E"
          recount={recount}
          onClick={() =>
            history.push(`${countPath ?? DOCUMENT_PATH}${ENTERED_PATH}`)
          }
        />
      )}

      <CountCard
        label="Pendientes"
        value={pending}
        icon="timelapse"
        backgroundColor="#D97706"
        recount={recount}
        onClick={() =>
          history.push(`${countPath ?? DOCUMENT_PATH}${PENDING_PATH}`)
        }
      />


      {!hidePendingRejected && (
        <CountCard
          label="Rechazados"
          value={rejected}
          icon="close"
          backgroundColor="#B91C1C"
          recount={recount}
          onClick={() =>
            history.push(`${countPath ?? DOCUMENT_PATH}${REJECTED_PATH}`)
          }
        />
      )}

      <CountCard
        label="Finalizados"
        value={completed}
        icon="flag"
        backgroundColor="#15803D"
        recount={recount}
        onClick={(e) => {
          e?.stopPropagation()
          history.push(`${countPath ?? DOCUMENT_PATH}${COMPLETED_PATH}`)
        }}
      />
    </div>
  )
})

export default CountDocuments